import { render } from "./ExternalSharePage.vue?vue&type=template&id=3e823cfa"
import script from "./ExternalSharePage.vue?vue&type=script&lang=js"
export * from "./ExternalSharePage.vue?vue&type=script&lang=js"
script.render = render

export default script